<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{ Object.entries(this.data).length === 0 ? "ADD NEW" : "UPDATE" }}
        TRUCK
      </h4>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <vs-input
          label="Truck Number Plate"
          v-model="number_plate"
          :disabled="Object.entries(this.data).length !== 0"
          class="mt-5 w-full"
          name="number-plate"
          v-validate="{
            required: true,
          }"
        />
        <!-- TODO: Include this to check if the number plate is valid 
              regex: /^[K]+([A-Z]{2})+[[:space:]]+(\d{3})+[A-Z]$/
         -->
        <span class="text-sm">{{
          Object.entries(this.data).length !== 0
            ? "Updating a number plate is forbidden"
            : "Input number plate as is to reduce errors"
        }}</span>
        <span class="text-danger text-sm" v-show="errors.has('number-plate')">
          <br />{{ errors.first("number-plate") }}</span
        >

        <vs-input
          label="Approx. Capacity in m3"
          v-model="m3"
          class="mt-5 w-full"
          name="m3"
          v-validate="'required|numeric'"
        />
        <span class="text-danger text-sm" v-show="errors.has('m3')">{{
          errors.first("m3")
        }}</span>

        <vs-textarea
          label="Description"
          v-model="description"
          class="mt-5 w-full"
        />

        <vs-divider>Driver Details</vs-divider>

        <vs-input
          label="Driver Name"
          v-model="driver_name"
          class="mt-5 w-full"
          name="driver-name"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('driver-name')">{{
          errors.first("driver-name")
        }}</span>

        <vs-input
          label="Driver Phone"
          v-model="driver_phone"
          class="mt-5 w-full"
          name="driver-phone"
          v-validate="'required|numeric|min:10|max:10'"
        />
        <span class="text-danger text-sm" v-show="errors.has('driver-phone')">{{
          errors.first("driver-phone")
        }}</span>

        <div class="vx-row mt-5 ml-1">
          <vs-switch class="mr-4" v-model="active"></vs-switch>
          <span class="text-sm">Truck Status</span>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else {
        let { _id, _rev, a, b, c, d, e, g } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.id = _id;
        this.rev = _rev;
        this.number_plate = a;
        this.m3 = b;
        this.description = c;
        this.driver_name = d;
        this.driver_phone = e;
        this.active = g;
        this.initValues();
      }
    },
  },
  data() {
    return {
      id: null,
      rev: null,
      number_plate: "",
      m3: 0,
      description: "",
      driver_name: "",
      driver_phone: "",
      active: true,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        this.number_plate &&
        this.m3 &&
        this.driver_name &&
        this.driver_phone
      );
    },
  },
  methods: {
    initValues() {
      if (this.data._id) return;
      this.id = null;
      this.number_plate = "";
      this.m3 = "";
      this.description = "";
      this.driver_name = "";
      this.driver_phone = "";
      this.active = true;
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.notify({
            color: "warning",
            title: "Processing",
            text: "Processing Data",
          });
          const obj = {
            _id: this.id,
            _rev: this.rev,
            a: this.number_plate.toUpperCase(),
            b: this.m3,
            c: this.description,
            d: this.driver_name.toUpperCase(),
            e: this.driver_phone,
            f: Date.now(),
            g: this.active,
            y: Date.now(),
            z: 2,
          };

          if (this.id !== null && this.rev !== null) {
            this.$store
              .dispatch("trucks/updateTruck", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          } else {
            delete obj._id;
            delete obj._rev;
            this.$store
              .dispatch("trucks/addTruck", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          }
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
